/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {EmptyValue} from "../../../Components/Common/EmptyValue";
import React from "react";

export function TextFieldViewer(props) {
	const {Value:value} = props;
	
	if((value ?? '') === '') {
		return <EmptyValue/>;
	}
	
	return value;
}
